<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <img class="rounded-circle details-profile-user mr-3"
                src="https://asset-a.grid.id/crop/0x0:0x0/700x465/photo/2020/06/17/1855621948.png" alt="Header Avatar" />
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-18 mb-1">{{ data.emp_name }}</h5>
                <p class="text-muted mb-0">Employee</p>
              </div>
            </div>
            <div class="table-responsive mt-3">
              <table class="table table-nowrap mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Divisi</th>
                    <td>
                      <router-link :to="{ name: 'divisi_detail', params: { uuid: data.div_uuid } }"> {{ data.div_name
                      }}</router-link>
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">Email</th>
                    <td>{{ data.emp_email }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Phone Number</th>
                    <td>{{ data.emp_phone }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Alamat</th>
                    <td>{{ data.emp_address }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Terima Order</th>
                    <td>{{ data.is_accept_order == 1 ? 'Ya' : 'Tidak' }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Gaji Pokok</th>
                    <td>Rp. {{ numberWithCommas(data.emp_gapok) }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Target</th>
                    <td>Rp. {{ numberWithCommas(data.emp_target) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a :class="'nav-link ' + (openTab == 'transaksi' ? 'active' : '')" aria-current="page"
              href="javascript:void(0)" @click="changeTab('transaksi')">History Transaksi</a>
          </li>
          <li class="nav-item">
            <a :class="'nav-link ' + (openTab == 'service' ? 'active' : '')" href="javascript:void(0)"
              @click="changeTab('service')">History Total Actual Service</a>
          </li>
          <li class="nav-item">
            <a :class="'nav-link ' + (openTab == 'payroll' ? 'active' : '')" href="javascript:void(0)"
              @click="changeTab('payroll')">Payroll</a>
          </li>
        </ul>
        <div class="card">
          <template v-if="openTab == 'transaksi'">
            <div class="card-body">
              <div>
                <tables v-if="childDataLoaded" module="Transaksi Servis" table_module="services_transaction"
                  alias_table="srv_t" :data="data_trans" :fields="fields_trans" @fetchData="fetchData"
                  :hidden-checkbox="false" :sortable="{
                    orderBy: orderBy,
                    sort: sort,
                  }"></tables>
              </div>
            </div>
          </template>
          <template v-if="openTab == 'service'">
            <div class="card-body">
              <div class="d-lg-flex align-items-center justify-content-between mb-4">
                <div class="align-items-center d-lg-flex d-none">
                  <label for="">Periode : </label>
                  <datepicker :minimumView="'month'" :maximumView="'year'" :initialView="'year'" format="MMM-yyyy"
                    input-class="form-control ml-2" v-model="periode" @input="getHistory()" />
                </div>
              </div>
              <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Invoice</th>
                    <th>Nama Service</th>
                    <th>Harga</th>
                    <th>Biaya External</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th colspan="5" class="bg-secondary"><b>Service</b></th>
                  </tr>
                  <tr v-for="(service, key) in data_service.data" :key="'A'+key">
                    <td>{{ service.transaksi_detail.transaksi.srv_t_code }}</td>
                    <td>{{ service.services.srv_name }}</td>
                    <td>Rp. {{ numberWithCommas(service.srv_act_price) }}</td>
                    <td>Rp. {{ numberWithCommas(service.srv_price_act_external) }}</td>
                    <td>Rp. {{ numberWithCommas(service.srv_act_price - service.srv_price_act_external) }}</td>
                  </tr>
                  <tr>
                    <th colspan="5" class="bg-secondary"><b>Bulk Service</b></th>
                  </tr>
                  <tr v-for="(service, key) in data_service.databulk" :key="'B'+key">
                    <td>{{ service.transaksi_detail.transaksi.srv_t_code }}</td>
                    <td>{{ service.service_bulk.srv_b_name }}</td>
                    <td>Rp. {{ numberWithCommas(service.service_bulk.srv_b_price_service) }}</td>
                    <td>Rp. {{ numberWithCommas(service.srv_b_price_external) }}</td>
                    <td>Rp. {{ numberWithCommas(service.service_bulk.srv_b_price_service - service.srv_b_price_external) }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="4" class="text-center"><b>Total Harga</b></td>
                    <td width="20%"><b>Rp. {{ numberWithCommas(data_service.total) }}</b></td>
                  </tr>
                </tfoot>
              </table>
            </div>
            </div>
          </template>
          <template v-if="openTab == 'payroll'">
            <div class="card-body">

            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import tables from "@/components/tables";
import Datepicker from "vuejs-datepicker";

export default {
  data() {
    return {
      visible: false,
      show: 10,
      page: 1,
      isLoading: false,
      module: "Employee",
      table_module: "employee",
      alias_table: "emp",
      uuid: this.$route.params.uuid,
      data: {},
      dataSearch: {},
      childDataLoaded: false,
      fields_trans: {},
      data_trans: {},
      openTab: 'transaksi',
      data_service: {},
      periode: this.$moment(new Date).format("MMM-YYYY")
    };
  },
  components: {
    tables, Datepicker
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.fetchData();
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    fetchData(arm) {
      this.visible = false;
      var params = {};
      if (arm == undefined) {
        params = {
          page: this.page,
          show: this.show,
          order_by: this.orderBy,
          type_sort: this.sort,
        };
      } else {
        params = {
          page: (arm.page == undefined) ? this.page : arm.page,
          show: (arm.show == undefined) ? this.show : arm.show,
          order_by: (arm.orderBy == undefined) ? this.orderBy : arm.orderBy,
          type_sort: (arm.sort == undefined) ? this.sort : arm.sort,
        };
      }

      this.orderBy = params.order_by;
      this.sort = params.type_sort;

      if (this.dataSearch.search != undefined) {
        for (const key in this.dataSearch.search) {
          params["search[" + key + "]"] = this.dataSearch.search[key];
        }
      }

      params["filter[emp_id]"] = this.data.emp_id;

      this.axios
        .get("/services_transaction", { params: params })
        .then((response) => {
          this.fields_trans = response.data.data.fields;
          this.data_trans = response.data.data["services_transaction"];
          this.childDataLoaded = true;
        });

      this.getHistory()
    },
    getHistory() {
      var periode = this.$moment(this.periode).format("MMM-YYYY")
      this.axios
        .get("/services_transaction/history_service/" + this.data.emp_id + '/' + periode)
        .then((response) => {
          this.data_service = response.data.data
          console.log(this.data_service)
        });
    },
    changeTab(open) {
      this.openTab = open
    }
  },
};
</script>